"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContent = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/no-cycle */
var React = tslib_1.__importStar(require("react"));
var TabStyles_1 = require("../../styles/TabStyles");
var AutoFocus_1 = require("../../utils/AutoFocus");
var Declarative_1 = require("../../utils/Declarative");
var DialogBody_1 = require("./DialogBody");
var DialogFooter_1 = require("./DialogFooter");
var DialogHeader_1 = require("./DialogHeader");
var DialogWidget_1 = require("./DialogWidget");
var DialogContentStyles = {
    boxSizing: 'border-box',
    color: TabStyles_1.TabStyles.Typography.Color.Primary,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    outline: 'none',
    overflow: 'hidden',
};
var DialogContent = /** @class */ (function (_super) {
    tslib_1.__extends(DialogContent, _super);
    function DialogContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogElement = React.createRef();
        _this.elementToReturnFocus = null;
        _this.sawESCkeyDown = false; // only handle ESC keyUp when dialog previously got ESC keyDown
        _this.handleDialogKeyUp = function (e) {
            if (e.key === 'Escape' && _this.sawESCkeyDown) {
                _this.sawESCkeyDown = false;
                _this.props.onCloseRequest();
            }
        };
        _this.handleDialogKeyDown = function (e) {
            if (e.key === 'Escape') {
                // eat Escape keyDown since we'll handle it in keyUp
                _this.sawESCkeyDown = true;
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        };
        return _this;
    }
    DialogContent.prototype.componentDidMount = function () {
        // Initially set the element to return focus to as the last active element.
        this.elementToReturnFocus = document.activeElement;
        this.initializeFocusOnMount();
        this.setFocusEventListener();
        document.addEventListener('focus', this.focusEventListener, true);
        // IE11 column-based flex containers need an explicit height to size flex children correctly. The symptom that we want to avoid
        // is when the content overflows the floater rather than shrinking, so apply this hack only if that happens.
        var dialogElement = this.dialogElement.current;
        if (dialogElement.offsetHeight > dialogElement.parentElement.clientHeight) {
            dialogElement.style.height = dialogElement.parentElement.clientHeight + "px";
        }
    };
    DialogContent.prototype.initializeFocusOnMount = function () {
        AutoFocus_1.autoFocus(this.props.disableAutoFocus, this.dialogElement.current, this.hasHeader && this.props.showCloseButton);
    };
    /**
     * If the dialog is nonModal it should keep track of the last element focused outside the dialog to be focused so when the dialog is
     * closed the focus can return to the last focused element.
     */
    DialogContent.prototype.setFocusEventListener = function () {
        var _this = this;
        this.focusEventListener = function (event) {
            if (!_this.props.isModal) {
                var target = event.target;
                if (!_this.dialogElement.current.contains(target)) {
                    _this.elementToReturnFocus = target;
                }
            }
        };
    };
    DialogContent.prototype.componentWillUnmount = function () {
        var _a;
        document.removeEventListener('focus', this.focusEventListener, true);
        // For non-modal dialog, we need to return focus to the most recently focused element outside of the dialog,
        // whereas for modal dialog, the return focus behavior is already provided by `ReactFocusLock`.
        if (this.props.shouldReturnFocusOnClose && !this.props.isModal) {
            (_a = this.elementToReturnFocus) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    Object.defineProperty(DialogContent.prototype, "hasHeader", {
        get: function () {
            return this.props.type !== DialogWidget_1.DialogType.Uber;
        },
        enumerable: false,
        configurable: true
    });
    DialogContent.prototype.render = function () {
        return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        React.createElement("div", { "aria-label": this.props.title, "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'Content'), onKeyDown: this.handleDialogKeyDown, onKeyUp: this.handleDialogKeyUp, ref: this.dialogElement, role: 'dialog', style: tslib_1.__assign(tslib_1.__assign({}, DialogContentStyles), this.props.dialogContentStyle), tabIndex: -1 },
            this.hasHeader && React.createElement(DialogHeader_1.DialogHeader, tslib_1.__assign({}, this.props)),
            React.createElement(DialogBody_1.DialogBody, { children: this.props.children, dialogBodyStyle: this.props.dialogBodyStyle, showFooter: !!this.props.footerContent, testId: this.props.testId, type: this.props.type }),
            !!this.props.footerContent &&
                React.createElement(DialogFooter_1.DialogFooter, { children: this.props.footerContent, sidePadding: DialogBody_1.getBodyPaddingStyle(this.props.type, true).paddingRight, testId: this.props.testId })));
    };
    return DialogContent;
}(React.Component));
exports.DialogContent = DialogContent;
//# sourceMappingURL=DialogContent.js.map